import React from 'react'
import { usePutRequest } from '../../../hooks/request'
import { CATEGORY_DETAIL } from '../../../urls'
import CategoryForm from './CategoryForm'

export default function CategoryUpdate({ onCancel, onSuccess, item }) {
    const brandUpdate = usePutRequest({ url: CATEGORY_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data) {
        const { success } = await brandUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Изменить</b>
            </h1>
            <CategoryForm loading={brandUpdate.loading} initialValues={item} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
